export default "__VITE_ASSET__BS3Bu94k__"